import { render, staticRenderFns } from "./studyStatistics.vue?vue&type=template&id=5ac65917"
import script from "./studyStatistics.vue?vue&type=script&lang=js"
export * from "./studyStatistics.vue?vue&type=script&lang=js"
import style0 from "./studyStatistics.vue?vue&type=style&index=0&id=5ac65917&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports